/** Backend (Laravel) product id for Rose Mist — used for the eligibility check. */
export const ROSE_MIST_PRODUCT_ID = 45;

const CONFIG_ELEMENT_ID = "so-fills-upsell-config";

export interface FillsUpsellConfig {
  roseMistVariantId: number;
  fourFillsVariantId: number;
  roseMistPriceCents: number;
  fourFillsPriceCents: number;
}

/**
 * Reads the JSON config block the theme renders on Mist product pages
 * (snippets/so-fills-upsell-config.liquid). Returns null anywhere the block
 * is absent or malformed — which disables the upsell entirely on that page.
 */
export function readFillsUpsellConfig(): FillsUpsellConfig | null {
  if (typeof document === "undefined") return null;
  const el = document.getElementById(CONFIG_ELEMENT_ID);
  if (!el?.textContent) return null;
  try {
    const raw = JSON.parse(el.textContent) as Record<string, unknown>;
    const config: FillsUpsellConfig = {
      roseMistVariantId: Number(raw.roseMistVariantId),
      fourFillsVariantId: Number(raw.fourFillsVariantId),
      roseMistPriceCents: Number(raw.roseMistPriceCents),
      fourFillsPriceCents: Number(raw.fourFillsPriceCents),
    };
    const valid = Object.values(config).every(
      (v) => Number.isFinite(v) && v > 0,
    );
    return valid ? config : null;
  } catch {
    return null;
  }
}
